const isServer = typeof window === "undefined";

export default isServer;
